var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.28,
    height: 17.999,
    viewBox: "0 0 21.28 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M.863,18a1.01,1.01,0,0,1,0-2H20.417a1.01,1.01,0,0,1,0,2Zm4.69-5.723L.789,9.895a1,1,0,0,1,0-1.789L5.553,5.724A1,1,0,0,1,7,6.618v4.765a1,1,0,0,1-1.447.894ZM9.442,10a.94.94,0,0,1-.867-1,.94.94,0,0,1,.867-1H20.133A.94.94,0,0,1,21,9a.94.94,0,0,1-.867,1ZM.863,2A.939.939,0,0,1,0,1,.939.939,0,0,1,.863,0H20.417a.939.939,0,0,1,.862,1,.939.939,0,0,1-.862,1Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeft);
export default __webpack_public_path__ + "static/media/menu-left.2d3edf575d2f3b3cbcaaa5522b167b80.svg";
export { ForwardRef as ReactComponent };